/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { CollectionItemChangeState } from "abreact/data/DataValueAccessor";
import { FeedbackUtils } from "abreact/feedback/FeedbackUtils";
import { AbItem } from "abreact/misc/AbItem";
import { AbSize } from "abreact/misc/AbSize";
import * as AbWebResources from "abweb/generated/locale/AbWebResources";
import { LogAndRenderErrorPipeline } from "abweb/utils/error/LogAndRenderErrorPipeline";
import * as React from "react";
export class AbFieldDecoratorFactory {
  static createFieldDecorators(props) {
    const decorators = [];
    const validationIssues = props.validationIssues ?? [];
    if (props.decorators) {
      decorators.push(...props.decorators);
    }
    if (props.revertFunction) {
      decorators.push({
        className: "revert-decorator",
        icon: "absdk:revert",
        size: AbSize.EXTRA_SMALL,
        tooltip: AbWebResources.uirevert0(),
        disabled: props.disabled,
        onClick: () => {
          props.revertFunction();
        }
      });
    }
    if (!props.readOnly && props.cannotEditReason) {
      decorators.push({
        className: "cannot-edit-decorator",
        icon: "absdk:lock",
        size: AbSize.EXTRA_SMALL,
        tooltip: props.cannotEditReason.message
      });
    }
    if (validationIssues.length > 0) {
      decorators.push(AbFieldDecoratorFactory.createValidationIssuesDecorator(validationIssues));
    }
    return decorators;
  }
  static createValidationIssuesDecorator(validationIssues) {
    const internalError = validationIssues.find(validationIssue => validationIssue.internalError !== undefined);
    if (internalError && internalError.internalError) {
      LogAndRenderErrorPipeline.pipeline.reportError(internalError.internalError);
    }
    const validationSeverities = validationIssues.map(issue => issue.severity);
    const highestSeverity = FeedbackUtils.getHighestSeverity(validationSeverities);
    const tooltip = validationIssues.length === 1 ? validationIssues[0].message : /*#__PURE__*/React.createElement("div", null, validationIssues.map(validationIssue => {
      return /*#__PURE__*/React.createElement(AbItem, {
        key: validationIssue.message,
        icon: FeedbackUtils.getValidationSeverityIconName(validationIssue.severity),
        label: validationIssue.message
      });
    }));
    return {
      className: "validation-issues-decorator",
      icon: highestSeverity ? FeedbackUtils.getValidationSeverityIconName(highestSeverity) : "absdk:warning",
      tooltip: tooltip
    };
  }
  static createCollectionItemDecorators(accessor, subject, item, skipValidationDecorator) {
    let decorators = [];
    if (item.clientChangeState === CollectionItemChangeState.ADDED || item.clientChangeState === undefined && item.serverChangeState === CollectionItemChangeState.ADDED) {
      decorators.push({
        className: "item-added-decorator",
        icon: item.cannotRemoveReason ? "absdk:added-locked" : "absdk:added",
        tooltip: AbWebResources.propertyItemCmp_itemAdded()
      });
    } else if (item.clientChangeState === CollectionItemChangeState.REMOVED || item.clientChangeState === undefined && item.serverChangeState === CollectionItemChangeState.REMOVED) {
      decorators.push({
        className: "item-removed-decorator",
        icon: accessor.cannotEdit && accessor.cannotEdit(subject) ? "absdk:deleted-locked" : "absdk:deleted",
        tooltip: AbWebResources.propertyItemCmp_itemRemoved()
      });
    }
    if (!skipValidationDecorator && item.validate !== undefined) {
      const validationIssues = item.validate(item.value);
      if (validationIssues.length > 0) {
        decorators.push(AbFieldDecoratorFactory.createValidationIssuesDecorator(item.validate(item.value)));
      }
    }
    return decorators;
  }
}
//# sourceMappingURL=AbFieldDecoratorFactory.js.map
